import Vue from "vue";
import Vuex from "vuex";
import { listRegions, listSchool, listWorkStateList } from "./services/api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    regionList: { lst: [] },
    schoolList: { lst: [] },
    stateList: { lst: [] }
  },
  mutations: {
    async setRegion(state) {
      state.regionList = await listRegions();
    },
    async setSchool(state, code) {
      state.schoolList = await listSchool(code);
    },
    async setStateList(state) {
      state.stateList = await listWorkStateList();
    }
  },
  actions: {
    setRegion(context) {
      context.commit("setRegion");
    },
    setSchool(context, data) {
      context.commit("setSchool", data.code);
    },
    setStateList(context) {
      context.commit("setStateList");
    }
  }
});
